export type ShinkansenTicketPickupNotice = {
  title: string;
  descriptionLines: string[];
  noteLine: string;
  bulletLines: string[];
  phoneNumber?: string;
};

const LEGACY_BULLET_LINES = [
  '・往路の出発駅でご依頼分【すべて（往路＋復路）】のチケットをお受け取りください',
  '・往路分だけを受け取った後、復路分を帰りの駅／乗り継ぎ駅で受け取ることができません',
  '・上記に沿わない場合、ご予約いただいた内容でご乗車いただくことができなくなります'
];

const resolvePickupStationLabel = (pickupStation?: string | null, ticketingMethod?: string | null): string => {
  if (!pickupStation) {
    return '往路の出発駅';
  }
  if (pickupStation === 'その他') {
    if (ticketingMethod === 'qr_east') {
      return 'JR東日本エリアの駅';
    }
    if (ticketingMethod === 'qr_west') {
      return 'JR西日本エリアの駅';
    }
    return '選択した発券サービスの対応駅';
  }
  return pickupStation;
};

const buildBulletLines = (stationLabel: string, hasSelectedStation: boolean): string[] => {
  if (!hasSelectedStation) {
    return LEGACY_BULLET_LINES;
  }
  return [
    `・${stationLabel}でチケットをお受け取りください`,
    '・選択した受け取り場所以外ではチケットを受け取れない場合があります',
    '・上記に沿わない場合、ご予約いただいた内容でご乗車いただくことができなくなります'
  ];
};

const buildNoteLine = (stationLabel: string, withNotePrefix: boolean): string => {
  const body = `チケットは「${stationLabel}」で受け取る必要があります`;
  return withNotePrefix ? `※${body}` : body;
};

export const buildShinkansenTicketPickupNotice = (
  ticketingMethod?: string | null,
  pickupStation?: string | null
): ShinkansenTicketPickupNotice | null => {
  const hasSelectedStation = !!pickupStation;
  const stationLabel = resolvePickupStationLabel(pickupStation, ticketingMethod);
  const bulletLines = buildBulletLines(stationLabel, hasSelectedStation);

  switch (ticketingMethod) {
    case 'qr_west':
      return {
        title: '【新幹線チケット受け取りについて】',
        descriptionLines: [
          'e5489でご予約の新幹線チケットは、',
          '発券機でQRコードを読み取り後、電話番号の入力を求められます。'
        ],
        noteLine: buildNoteLine(stationLabel, true),
        bulletLines,
        phoneNumber: '0344055753'
      };
    case 'qr_east':
      return {
        title: '【新幹線チケット受け取りについて】',
        descriptionLines: [],
        noteLine: buildNoteLine(stationLabel, false),
        bulletLines
      };
    default:
      return null;
  }
};
